import styled from "styled-components";
import {LIVE_CASINO_PAGE} from "../../../../themes/css-global-classes";
import {TopBannerTitleDefaultBox} from "./top-banner-title.default.box";

export const TopBannerTitleCasino777Box = styled(TopBannerTitleDefaultBox)`
    ${({theme}) => theme.font.presets.bold};
    .${LIVE_CASINO_PAGE} &{
        display:none;
    }
`;
